import React from "react";
import useReveal from "../../hooks/useReveal";

/**
 * Scroll-reveal wrapper. `delay` staggers children (ms).
 */
function Reveal({ children, delay = 0, as: Tag = "div", className = "", ...rest }) {
  const [ref, visible] = useReveal();

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
